import { httpPost } from "../http"

export interface CalculateFareRequest {
  last_selected_vehicle_type: number
  pick_up: {
    pickup_location_address: string
    pickup_location_address_name: string
    latitude: number
    longitude: number
  }
  drop_off: {
    drop_location_address: string
    drop_location_address_name: string
    latitude: number
    longitude: number
  }
  city: number
  booking_service_type: number
  coupon_id?: number
  expected_highlight_vehicles: number[]
  best_coupon_disabled?: boolean
  promo_id?: number
  preferred_payment_mode?: number
  business_id?: string
  card_id?: string
  is_befar?: number
}

export interface CalculateFareResponse {
  flag: number
  error: string
  message: string
  dev_message: string
  prices: VehicleWithPrice[]
  far_away_city: string
  booking_service_type: number
  promote_prices: VehicleWithPrice[]
  promoted_payment_mode: number
  goong_prices: VehicleWithPrice[]
  goong_promote_prices: VehicleWithPrice[]
  tabs: Tab[]
}

export interface Tab {
  id: number
  name: string
  vehicle_types: number[]
}

export interface VehicleWithPrice {
  vehicle_type: number
  fare: Fare
  region_id: number
  region_name: string
  vehicle_name: string
  distance: number
  eta: number
}

interface Fare {
  fare: number
}

export function V1CalculateFare(body: CalculateFareRequest) {
  return httpPost<CalculateFareResponse>(
    "be-fare/customer/calculate_fare",
    body
  ).then((res) => res.data)
}
